<template>
  <div class="block block-rounded block-bordered">
    <div class="block-header block-header-default">
      <h3 class="block-title">List of submitted forms</h3>
    </div>
    <div class="block-content">
      <table class="table table-hover table-vcenter">
        <thead>
          <tr>
            <th class="text-center" style="width: 50px">#</th>
            <th>Name</th>
            <th class="d-none d-sm-table-cell">Action Type</th>
            <th class="d-none d-sm-table-cell">Address</th>
            <th class="d-none d-sm-table-cell">Created</th>
            <th class="text-center" style="width: 100px">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, key) in allSubmits.data" :key="item.id">
            <th class="text-center" scope="row">
              {{
                $route.query.page > 1
                  ? parseInt($route.query.page) * 10 + key + 1
                  : key + 1
              }}
            </th>
            <td class="font-w600">
              <a :href="'/SubmittedForm/' + item.id">{{
                item.name.length > 25
                  ? item.name.substring(0, 25) + "..."
                  : item.name === " "
                  ? "undefined"
                  : item.name
              }}</a>
            </td>
            <td>
              <span class="badge" style="color:black">{{ item.formtype }}</span>
            </td>
            <td>
              <span class="badge" style="color:black">{{ item.adres }}</span>
            </td>
            <td class="d-none d-sm-table-cell">
              <span>{{ item.created_at | moment }}</span>
            </td>
            <td class="text-center">
              <div class="btn-group">
                <a
                  :href="'/SubmittedForm/' + item.id"
                  class="btn btn-sm btn-outline-secondary"
                  data-toggle="tooltip"
                  title="View"
                >
                  <i class="fa fa-eye"></i>
                </a>
                <button
                  class="btn btn-sm btn-outline-secondary"
                  :class="
                    item.message
                      ? item.message.status_code
                        ? /^2/.test(item.message.status_code)
                          ? 'submit-ok'
                          : 'submit-error'
                        : 'submit-ok'
                      : 'submit-error'
                  "
                  @click="alertSubmitMessage(item.message)"
                >
                  <i
                    class="far fa-question-circle fa-lg"
                    style="color: white"
                  ></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-12 pb-3 pr-4">
          <div
            class="btn-group btn-group-lg float-right"
            role="group"
            aria-label="Large Horizontal Outline Primary"
          >
            <a
              v-if="currentPage !== 1 && currentPage !== 0"
              :href="'submits?page=' + (currentPage - 1)"
            >
              <button type="button" class="btn btn-outline-info">
                <i class="fa fa-arrow-left"></i>
              </button>
            </a>
            <a href="javascript:void(0)">
              <button
                type="button"
                class="btn btn-outline-info ml-3 mr-3"
                disabled
              >
                {{ currentPage }}
              </button>
            </a>
            <a
              v-if="currentPage !== lastPage"
              :href="'submits?page=' + (currentPage + 1)"
            >
              <button type="button" class="btn btn-outline-info">
                <i class="fa fa-arrow-right"></i>
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  name: "SubmitsList",
  components: {},
  data() {
    return {
      currentPage: 1,
      lastPage: 1
    };
  },
  methods: {
    ...mapActions({
      getAllSubmit: "forms/getAllSubmit"
    }),
    moment: function() {
      return moment();
    },
    alertSubmitMessage(message) {
      if (message === null) {
        this.$swal({
          icon: "error",
          title: "",
          html: "<p class='mb-0'>Message is corrupted</p>"
        });
        return;
      }

      let m = message.message;

      if (message.status_code && !/^2/.test(message.status_code)) {
        if (message.errors) {
          Object.values(message.errors).forEach(x => {
            m += "<p class='mb-0'>- " + x + "</p>";
          });
        }
        this.$swal({
          icon: "error",
          title: "",
          html: m
        });
      } else {
        this.$swal({
          icon: "success",
          title: "",
          html: m
        });
      }

      // if (message.errors) {
      //   Object.values(message.errors).forEach(x => {
      //     message += "<p class='mb-0'>- " + x + "</p>";
      //   });
      //   this.$swal({
      //     icon: "error",
      //     title: "",
      //     html: message
      //   });
      // } else {
      //   this.$swal({
      //     icon: "success",
      //     title: "",
      //     html: message
      //   });
      // }
    }
  },
  computed: {
    ...mapState({
      allSubmits: state => state.forms.AllSubmits
    })
  },
  mounted() {
    this.getAllSubmit().then(response => {
      this.currentPage = response.data.meta.current_page;
      this.lastPage = response.data.meta.last_page;
    });
  },
  filters: {
    moment: function(date) {
      //  return moment(date).format("MMMM Do YYYY, h:mm:ss a");
      return moment(date).format("DD-MM-YYYY, H:mm:ss");
    }
  }
};
</script>

<style scoped>
.submit-error {
  background-color: #dc3545 !important;
  color: black !important;
}

.submit-ok {
  background-color: #28a745 !important;
  color: black !important;
}
</style>
